import { Action } from '../actions/types'

const INITIAL_STATE = {
    session: {},
    data: {},
    isLoggedIn: false,
    loading_user: false,
    uploadingImage: false,
    uploadProgress: 0,
    requestList: [],
    lastVisible: {},
    lastPage: false,
    error: {}
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case Action.USER_ACTION:
            return {
                ...state,
                loading_user: true,
                error: {}
            }
        case Action.USER_AUTHENTICATED:
            return {
                ...state,
                session: action.payload.session,
                data: action.payload.data,
                isLoggedIn: true,
                loading_user: false,
                error: {}
            }
        case Action.USER_LOGGED_IN:
            return {
                ...state,
                session: action.payload.session,
                data: action.payload.data
            }
        case Action.USER_ERROR:
            return {
                ...state,
                loading_user: false,
                error: action.payload
            }
        case Action.USER_ERROR_RESET:
            return {
                ...state,
                error:{}
            }
        case Action.FORGOT_PASSWORD_SENT:
            return {
                ...state,
                loading_user: false,
                error: action.payload
            }
        case Action.LOGOUT:
            return INITIAL_STATE
        case Action.PROFILE_IMAGE_UPLOADING:
            return {
                ...state,
                uploadingImage: true,
                uploadProgress: 0
            }
        case Action.PROFILE_IMAGE_UPLOAD_PROGRESS:
            return {
                ...state,
                uploadProgress: action.payload.progress
            }
        case Action.PROFILE_IMAGE_UPLOADED:
            return {
                ...state,
                uploadingImage: false,
                uploadProgress: 100,
                data: {
                    ...state.data,
                    profileImage: action.payload
                }
            }
        case Action.USER_INITIAL_REQUESTS:
            return {
                ...state,
                loading_user: false,
                requestList: action.payload.list,
                lastVisible: action.payload.lastVisible,
                lastPage: action.payload.lastPage
            }
        case Action.USER_MORE_REQUESTS: 
            return {
                ...state,
                loading_user: false,
                requestList: [ ...state.requestList, ...action.payload.list],
                lastVisible: action.payload.lastVisible,
                lastPage: action.payload.lastPage
            }
        case Action.USER_RESET_REQUESTS:
            return {
                ...state,
                requestList: []
            }
        default:
            return state
        }
}